import { useSnippetsPermissions } from '../../../../../../features/teams';

import { SidebarTabLayout } from '../../../../../../features/editor-left-sidebar/ui/components/shared/SidebarTabLayout';
import { AccessSettingsForm } from './AccessSettingsForm';
import { ChangeSnippetNameForm } from './ChangeSnippetNameForm';
import { ChangeSnippetDescriptionForm } from './ChangeSnippetDescriptionForm';

export const SnippetSidebarSettingsTab = () => {
  const { isCanCreatePersonalSnippets, isCanManageSnippets } =
    useSnippetsPermissions();

  const isVisibleSharingAccessButtons =
    isCanCreatePersonalSnippets && isCanManageSnippets;

  return (
    <div className="w-120">
      <SidebarTabLayout>
        <p className="text-xs font-semibold text-gray-500 uppercase mb-3">
          Snippet settings
        </p>
        <div className="flex flex-col gap-3 mb-5">
          <ChangeSnippetNameForm />

          <ChangeSnippetDescriptionForm />

          {isVisibleSharingAccessButtons && <AccessSettingsForm />}
        </div>
      </SidebarTabLayout>
    </div>
  );
};
